<div class="container mx-auto device-content">
    <form #form="ngForm" class="form container-fluid pl-0 pr-0">
        <div class="hero-text" div fxLayout="row" fxLayoutAlign="space-between center" style="margin-left: 10px;">
            <h1 style="font-weight: 800;">{{'LAST_STATUS' | translate}}</h1>
            <div>
                <strong>{{'DEVICE_ID'|translate}}{{' = '}}</strong>
                <span>{{model.device.id!=null?model.device.id:'---'}}</span>
            </div>
        </div>
        <div fxLayout="row wrap" fxLayoutAlign="start start">
            <div fxFlex="100" fxFlex.gt-md="100" class="p-20 h-100-p">
                <div fxLayout="row wrap" class="last-status-card h-100-p">
                    <div fxFlex="100" class="last-status-card-header">
                        <h3 style="padding: 10px; padding-bottom: 0px;">{{'GPS_INFORMATION'|translate}}</h3>
                    </div>
                    <div fxFlex="100" class="location-content last-status-card-item" (click)="onMapClick()">
                        <strong style="display: block;">{{'LOCATION'|translate}}</strong>
                        <span>{{(model?.device?.deviceLatestStatus.gpS_Enlem!=null?(model?.device?.deviceLatestStatus.gpS_Enlem):'')+" / "+(model?.device?.deviceLatestStatus.gpS_Boylam!=null?(model?.device?.deviceLatestStatus.gpS_Boylam):'')}}</span>
                        <mat-icon>location_on</mat-icon>
                    </div>
                    <div fxFlex="33.3" class="last-status-card-item">
                        <strong style="display: block;">{{'GPS_FIX'|translate}}</strong>
                        <span>{{model?.device?.deviceLatestStatus.gpS_Fix!=null?(model?.device?.deviceLatestStatus.gpS_Fix):'---'}}</span>
                    </div>
        
                    <div fxFlex="33.3" class="last-status-card-item">
                        <strong style="display: block;">{{'NUMBER_OF_GPS_SATELLITES'|translate}}</strong>
                        <span>{{model?.device?.deviceLatestStatus.gpS_UyduSayisi!=null?(model?.device?.deviceLatestStatus.gpS_UyduSayisi):'---'}}</span>
                    </div>
        
                    <div fxFlex="33.3" class="last-status-card-item">
                        <strong style="display: block;">{{'NUMBER_OF_GPS_LISTENING'|translate}}</strong>
                        <span>{{model?.device?.deviceLatestStatus.gpS_DinlemeSayisi!=null?(model?.device?.deviceLatestStatus.gpS_DinlemeSayisi):'---'}}</span>
                    </div>
        
                    <div fxFlex="33.3" class="last-status-card-item">
                        <strong style="display: block;">{{'GPS_ALTITUDE'|translate}}</strong>
                        <span>{{model?.device?.deviceLatestStatus.gpS_Rakim!=null?(model?.device?.deviceLatestStatus.gpS_Rakim):'---'}}</span>
                    </div>
        
                    <div fxFlex="33.3" class="last-status-card-item">
                        <strong style="display: block;"> {{'GPS_SIGNAL'|translate}}</strong>
                        <span>{{model?.device?.deviceLatestStatus.gsM_Sinyal!=null?(model?.device?.deviceLatestStatus.gsM_Sinyal):'---'}}</span>
                    </div>
        
                </div>
            </div>

            <div fxFlex="100" fxFlex.gt-md="100" class="p-20 h-100-p">
                <div fxLayout="row wrap" class="last-status-card h-100-p">
                    <div  fxFlex="100" class="last-status-card-header">
                        <h3 style="padding: 10px;  padding-bottom: 0px;">{{'STATUS_INFORMATION'|translate}}</h3>
                    </div>
                    <div fxFlex="33.3" class="last-status-card-item">
                        <strong style="display: block;">{{'SOLAR_ENERGY_VOLATILITY'|translate}}</strong>
                        <span>{{model?.device?.deviceLatestStatus.solarEnerjiVoltaj!=null?(model?.device?.deviceLatestStatus.solarEnerjiVoltaj):'---'}}</span>
                    </div>
                    
                    <div fxFlex="33.3" class="last-status-card-item">
                        <strong style="display: block;">{{'BATTERY'|translate}}</strong>
                        <span>{{model?.device?.deviceLatestStatus.batarya!=null?(model?.device?.deviceLatestStatus.batarya):'---'}}</span>
                    </div>

                    <div fxFlex="33.3" class="last-status-card-item">
                        <strong style="display: block;">{{'CPU_HEAT'|translate}}</strong>
                        <span>{{model?.device?.deviceLatestStatus.cpuSicaklik!=null?(model?.device?.deviceLatestStatus.cpuSicaklik):'---'}}</span>
                    </div>

                    <div fxFlex="33.3" class="last-status-card-item">
                        <strong style="display: block;">{{'FIRMWARE'|translate}}</strong>
                        <span>{{model?.device?.deviceLatestStatus.firmware!=null?(model?.device?.deviceLatestStatus.firmware):'---'}}</span>
                    </div>
        
        
                    <div fxFlex="33.3" class="last-status-card-item">
                        <strong style="display: block;">{{'DISTANCE'|translate}}</strong>
                        <span>{{model?.device?.deviceLatestStatus.mesafe!=null?(model?.device?.deviceLatestStatus.mesafe):'---'}}</span>
                    </div>
             
                     <div fxFlex="33.3" class="last-status-card-item">
                         <strong style="display: block;">{{'LAST_CONNECTION_DATE'|translate}}</strong>
                        <span>{{model?.device?.deviceLatestStatus.sonBaglantiTarih!=null?(model?.device?.deviceLatestStatus.sonBaglantiTarih | date:"dd/MM/y HH:mm"):'---'}}</span>
                     </div>
                </div>
            </div>
            
            <div fxFlex="100" class="p-20" >
                <div fxLayout="row wrap" class="last-status-card">
                    <div fxFlex="100"  class="last-status-card-header">
                        <h3 style="padding: 10px;  padding-bottom: 0px;">{{'OTHER_INFORMATION'|translate}}</h3>
                    </div>
                    <div fxFlex="50" class="last-status-card-item">
                        <strong style="display: block;">{{'ON_TIME'|translate}}</strong>
                        <span>{{model?.device?.deviceLatestStatus.acikKalmaSuresi!=null?(model?.device?.deviceLatestStatus.acikKalmaSuresi):'---'}}</span>
                    </div>
        
                    <div fxFlex="50" class="last-status-card-item">
                        <strong style="display: block;">{{'GSM_CONNECTION_TIME'|translate}}</strong>
                        <span>{{model?.device?.deviceLatestStatus.gsM_BaglantiSuresi!=null?(model?.device?.deviceLatestStatus.gsM_BaglantiSuresi):'---'}}</span>
                    </div>
        
                    <div fxFlex="50" class="last-status-card-item">
                        <strong style="display: block;">{{'INSUFFICIENT_BATTERY_COUNT'|translate}}</strong>
                        <span>{{model?.device?.deviceLatestStatus.yetersizBataryaUyanamamaCount!=null?(model?.device?.deviceLatestStatus.yetersizBataryaUyanamamaCount):'---'}}</span>
                    </div>
        
                    <div fxFlex="50" class="last-status-card-item">
                        <strong style="display: block;">{{'GSM_SIGNAL_WARNING'|translate}}</strong>
                        <span>{{model?.device?.deviceLatestStatus.gsM_SinyaliYakalayamamaCount!=null?(model?.device?.deviceLatestStatus.gsM_SinyaliYakalayamamaCount):'---'}}</span>
                    </div>
        
                    <div fxFlex="50" class="last-status-card-item">
                        <strong style="display: block;">{{'UNABLE_FIX_GPS'|translate}}</strong>
                        <span>{{model?.device?.deviceLatestStatus.gpS_VerisiFixleyememeCount!=null?(model?.device?.deviceLatestStatus.gpS_VerisiFixleyememeCount):'---'}}</span>
                    </div>
        
                    <div fxFlex="50" class="last-status-card-item">
                        <strong style="display: block;">{{'SERVER_COMMUNICATION_COUNT'|translate}}</strong>
                        <span>{{model?.device?.deviceLatestStatus.sunucuHaberlesememeCount!=null?(model?.device?.deviceLatestStatus.sunucuHaberlesememeCount):'---'}}</span>
                    </div>
        
                    <div fxFlex="50" class="last-status-card-item">
                        <strong style="display: block;">{{'MAX_AWAKE_TIME_EXCEEDED'|translate}}</strong>
                        <span>{{model?.device?.deviceLatestStatus.maxUyaniklikSuresiAsmaCount!=null?(model?.device?.deviceLatestStatus.maxUyaniklikSuresiAsmaCount):'---'}}</span>
                    </div>
        
        
                </div>
            </div>
        </div>
    </form>
</div>